import React from 'react'
import CheckboxCom from '../checkbox/CheckboxComp'
import { LabelCheck } from '../label/Label'
import './labeledCheckbox.scss'

const LabeledCheckbox = ({
  idLabel,
  label,
  required,
  specificClass,
  name,
  onChange,
  checked,
  disabled,
}) => {
  return (
    <div className="flex-container">
      <div className="control-input-check">
        <LabelCheck
          id={idLabel}
          label={label}
          required={required}
          specificClass={specificClass}
        />
        <CheckboxCom
          name={name}
          onChange={onChange}
          checked={checked}
          disabled={disabled}
        />
      </div>
    </div>
  )
}

export default LabeledCheckbox
